export default "__VITE_ASSET__69e71902__"